module.exports = __webpack_public_path__ + "static/18-43fd456e7656d9a2164731aa4b09129c.png";